import './css/index.css'
import 'virtual:svg-icons-register'
import 'swiped-events'

import type { Component } from 'vue'
import { config, init } from './services/init'

import { toastPlugin } from './plugins/toast'
import { initShopifyCustomizer } from './services/shopify'

import { loadLocale, revealHiddenElements, scrollToSelector } from './utils'

const createVueApp = config({
  name: 'theme',
  components: import.meta.glob<Component>('./components/theme/**/*.(vue|[jt]s)', { eager: true }),
  asyncComponents: import.meta.glob<Component>('./components/pages/**/*.vue')
})

init(async () => {
  const $el = document.querySelector('#app')
  if (!($el instanceof HTMLElement) || $el.getAttribute('init')) {
    return
  }
  $el.setAttribute('init', new Date().toJSON())

  const app = createVueApp()
  app.use(toastPlugin)

  // load current locale
  await loadLocale(app.config.globalProperties.$theme.locale)

  // remove skeleton loaders
  document.querySelectorAll('.skeleton-liquid').forEach(i => i.parentElement?.removeChild(i))

  // mount app
  app.mount($el)

  // show hidden vue elements on dom ready
  revealHiddenElements()

  // add scroll to utility
  document.querySelectorAll('[data-scroll-to]').forEach(i => {
    i.addEventListener('click', (e) => {
      e.preventDefault()
      const sel = i.getAttribute('data-scroll-to')
      if (sel) {
        scrollToSelector(sel)
      }
    })
  })

  document.querySelectorAll('a[href="#product-bundler"]').forEach(i => {
    i.addEventListener('click', (e) => {
      e.preventDefault()
      scrollToSelector('#product-bundler', 120)
    })
  })

  const newsletterForm = document.querySelector('#newsletter-form')
  if (newsletterForm && window?.Shopify?.captcha) {
    window.Shopify.captcha.protect(newsletterForm)
  }

  initShopifyCustomizer(app)
})
